// extracted by mini-css-extract-plugin
export var home = "Layout-module--home--0c863";
export var main = "Layout-module--main--580ca";